import { db } from "../../firebase";
import Vue from "vue";

const state = {
  karteData: {},
  diagnosisDate: "",
  status: ""
};

const mutations = {
  fetchKarte(state, payload) {
    state.karteData = payload;
    state.status = "fetch";
  },
  setKarte(state, payload) {
    Vue.set(state.karteData, payload.date, payload.karteData);
    payload.karteData.user = "api_test_1";
    state.diagnosisDate = payload.date;
    state.status = "set";
  },
  deleteKarte(state, date) {
    Vue.Delete(state.karteData, date);
    state.status = "delete";
  },
  clear(state) {
    state.karteData = {};
    state.diagnosisDate = "";
    state.status = "";
  },
  setDiagnosisDate(state, payload) {
    state.diagnosisDate = payload.date;
  }
};
const actions = {
  fetchKarte({ commit }, payload) {
    commit("fetchKarte", payload);
  },
  setKarte({ commit }, payload) {
    commit("setKarte", payload);
  },
  deleteKarte({ commit }, date, payload) {
    commit("deleteKarte", date, payload);
  },
  setDiagnosisDate({ commit }, payload) {
    commit("setDiagnosisDate", payload);
  },
  // Firebaseから全てのからだ手帳データを取得
  async fetchKarteFromFirebase({ commit }, uid) {
    try {
      const snapshot = await db.ref(`/karte/${uid}`).once("value");
      if (snapshot.val()) {
        commit("fetchKarte", snapshot.val());
      } else {
        commit("fetchKarte", {});
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  },
  // Firebaseに指定した日付のからだ手帳データを新規登録、上書き
  // TODO 修正
  async sendKarteToFirebase({ dispatch, commit, state }, payload) {
    // 指定した日付のデータが存在する場合
    if (Object.keys(state.karteData).find(v => v.key === payload.date)) {
      // 日付が存在する場合はアップデート
      dispatch("updateKarteToFirebase", {
        uid: payload.uid,
        date: payload.date,
        payload: payload.karteData
      });
    } else {
      try {
        await db
          .ref(`/karte/${payload.uid}/${payload.date}`)
          .set(payload.karteData);
        commit("setKarte", payload.date, payload.karteData);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error.message);
      }
    }
  },
  // 既にstoreされているデータをFirebaseに送信する
  async sendKarteToFirebaseByCharge({ state }, uid) {
    try {
      if (state.karteData[state.diagnosisDate]) {
        await db
          .ref(`/karte/${uid}/${state.diagnosisDate}`)
          .update(state.karteData[state.diagnosisDate]);
      } else {
        throw new Error("No Karte Data");
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  },
  // Firebaseに指定した日付のからだ手帳データをアップデート
  async updateKarteToFirebase({ commit }, uid, date, karteData) {
    try {
      await db.ref(`/karte/${uid}/${date}`).update(karteData);
      commit("setKarte", date, karteData);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  },
  // Firebaseに指定した日付のからだ手帳データを削除
  async deleteKarteToFirebase({ commit }, uid, date) {
    try {
      await db.ref(`/karte/${uid}/${date}`).update(null);
      commit("deleteKarte", date);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  }
};

const getters = {
  getDiagnosisDate: state => {
    if (state.karteData && state.diagnosisDate) {
      return state.diagnosisDate;
    } else {
      return "";
    }
  },
  getKarteData: state => {
    if (state.karteData && state.diagnosisDate) {
      return state.karteData;
    } else {
      return "";
    }
  },
  getKarteDateList: state => {
    return Object.keys(state.karteData);
  },
  getFeaturesByDate: state => {
    return state.karteData[state.diagnosisDate].features[0];
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
